import { render, staticRenderFns } from "./ConsentSheet.vue?vue&type=template&id=f4a31518&scoped=true"
import script from "./ConsentSheet.vue?vue&type=script&lang=js"
export * from "./ConsentSheet.vue?vue&type=script&lang=js"
import style0 from "./ConsentSheet.vue?vue&type=style&index=0&id=f4a31518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a31518",
  null
  
)

export default component.exports